import AxiosClient from '..';
import { AdwordsAPIResponse, GetAttributesPayload } from './types';

const AdwordsAPI = {
  getAttributes: (payload: GetAttributesPayload) =>
    AxiosClient.post<unknown, AdwordsAPIResponse>('/generic-db/google-keywords', payload)
};

export default AdwordsAPI;
